import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-915a1908")

_pushScopeId("data-v-915a1908")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Perizie")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "page_content"
}
const _hoisted_4 = {
  key: 0,
  class: "no_interventi_container"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "no_interventi" }, "Nessun perizia effettuata", -1)
const _hoisted_6 = {
  key: 1,
  class: "container_interventi"
}
const _hoisted_7 = { class: "pratica_info" }
const _hoisted_8 = { class: "date" }
const _hoisted_9 = { class: "customer" }
const _hoisted_10 = { class: "status" }
const _hoisted_11 = { class: "danno" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadPerizie()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                (!$setup.perizie.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_4, [
                      _hoisted_5
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_6, [
                      _createVNode("div", null, [
                        _createVNode(_component_ion_input, {
                          type: "text",
                          "clear-input": "",
                          modelValue: $setup.searchQuery,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($setup.searchQuery = $event)),
                          placeholder: "Cerca perizia",
                          class: "search_perizia"
                        }, null, 8, ["modelValue"])
                      ]),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.searchedPerizie, (perizia) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "pratica",
                          key: perizia.pratiche_assicurative_id,
                          onClick: ($event: any) => ($setup.periziaDetail(perizia))
                        }, [
                          _createVNode("div", _hoisted_7, [
                            _createVNode("div", _hoisted_8, _toDisplayString(perizia.pratiche_assicurative_protocollo) + " - " + _toDisplayString($setup.riferimentoCliente(perizia)), 1),
                            _createVNode("div", _hoisted_9, _toDisplayString(perizia.compagnie_nome), 1)
                          ]),
                          _createVNode("div", _hoisted_10, [
                            _createVNode("div", _hoisted_11, "Danno: " + _toDisplayString(perizia.tipologie_danni_nome ? perizia.tipologie_danni_nome : "-"), 1),
                            _createVNode("span", {
                              class: ["badge", $setup.statoPerizia(perizia.pratiche_assicurative_stato)]
                            }, _toDisplayString(perizia.tipologie_stati_nome), 3)
                          ])
                        ], 8, ["onClick"]))
                      }), 128))
                    ]))
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})